import Grid from "@mui/material/Grid2";
import React from "react";
import { Paper } from "@mui/material";
import Box from '@mui/material/Box';
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import parse from "html-react-parser";
import "./index.css"
import { useAppSelector } from "@store/hooks";
import { generateScript } from './../../../../../../../../utilities/general/index';

const name = "ChargeBanner"

type Props = {
    parent: string
}

const ChargeBanner: React.FC<Props> = ({ parent }) => {
    const rateText = useAppSelector(({ ui }) => ui.RateText)
    const ratesDiscount = useAppSelector(({ ui }) => ui.RatesDiscount)
    const rateReason = useAppSelector(({ ui }) => ui.RatesRateReason)
    const debugName = `${parent}▷[${name}]`

    React.useEffect(() => {
        generateScript();
    }, [ratesDiscount, rateReason])

    useDebugInformation(debugName, { newRate: rateText })
    return (
        (<Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(0),
            marginBottom: theme.spacing(1),
            marginLeft: 0,
            marginRight: 0,
            padding: theme.spacing(1),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(1),
                padding: theme.spacing(2),
            },
        })}>
            <Grid container spacing={2} >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Box textAlign="center">{parse(String(rateText))}</Box>
                </Grid>
            </Grid>
        </Paper >)
    );
}

export default React.memo(ChargeBanner)